import React, { createContext, useContext, ReactNode } from 'react'
import { useNotifications } from '../hooks/useNotifications'
import NotificationSystem from '../components/common/NotificationSystem'

interface NotificationContextType {
  showSuccess: (title: string, message?: string, duration?: number) => string
  showError: (title: string, message?: string, duration?: number) => string
  showWarning: (title: string, message?: string, duration?: number) => string
  showInfo: (title: string, message?: string, duration?: number) => string
  showConfirm: (title: string, message?: string) => Promise<boolean>
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

interface NotificationProviderProps {
  children: ReactNode
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const {
    notifications,
    removeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm
  } = useNotifications()

  const contextValue: NotificationContextType = {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm
  }

  return (
    <NotificationContext.Provider value={contextValue}>
      <NotificationSystem 
        notifications={notifications} 
        onRemove={removeNotification} 
      />
      {children}
    </NotificationContext.Provider>
  )
}

export function useNotificationContext(): NotificationContextType {
  const context = useContext(NotificationContext)
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider')
  }
  return context
}
